/**
 *
 *
 * Expandable Table Field
 *
 */

import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  Label,
  FormGroup,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
} from "reactstrap"
import { capitalizeFirstLetter } from "../../helpers/tools"
import BootstrapTable from "react-bootstrap-table-next"
import "./table.css"

const DropdownFormatter = ({ accessList, onChange, value, row }) => {
  const [link, setLink] = useState(false)
  const accessOpt =
    (accessList &&
      accessList.length > 0 &&
      (accessList || []).filter(
        (a) => !a.isDefault && row.access.includes(a._id)
      )) ||
    []
  return !row.children && accessOpt && accessOpt.length > 0 ? (
    <ButtonDropdown isOpen={link} toggle={() => setLink(!link)}>
      <DropdownToggle caret color="secondary">
        More Options <i className="mdi mdi-chevron-down"></i>
      </DropdownToggle>
      <DropdownMenu onClick={() => setLink(true)}>
        {(accessOpt || []).map((list) => (
          <DropdownItem key={list._id}>
            <FormGroup className="mb-3">
              <div className="form-check">
                <Label
                  className="form-check-label"
                  htmlFor={`${row._id}-${list._id}`}
                >
                  {" "}
                  {list.accessName}
                </Label>
                <Input
                  type="checkbox"
                  className="form-check-input"
                  id={`${row._id}-${list._id}`}
                  name={list._id}
                  onChange={(e) => {
                    const filterVal =
                      (value && value.filter((_) => _.menuId === row._id)) || []
                    const changedVal =
                      filterVal && filterVal.length > 0
                        ? (value || []).map((el) => {
                            if (
                              el &&
                              el.menuId &&
                              el.access &&
                              el.menuId === row._id &&
                              el.access.includes(e.target.name)
                            ) {
                              return Object.assign({}, el, {
                                access: el.access.filter(
                                  (id) => id === e.target.name
                                ),
                              })
                            } else if (
                              el &&
                              el.menuId &&
                              el.access &&
                              el.menuId === row._id &&
                              !el.access.includes(e.target.name)
                            ) {
                              return Object.assign({}, el, {
                                access: [...el.access, e.target.name],
                              })
                            } else {
                              return el
                            }
                          })
                        : value && value.length > 0
                        ? [
                            ...value,
                            Object.assign(
                              {},
                              { menuId: row._id, access: [e.target.name] }
                            ),
                          ]
                        : [
                            Object.assign(
                              {},
                              { menuId: row._id, access: [e.target.name] }
                            ),
                          ]
                    onChange({ target: { value: changedVal } })
                  }}
                  checked={
                    (value &&
                      value.find(
                        (_) =>
                          _.menuId === row._id && _.access.includes(list._id)
                      )) ||
                    false
                  }
                />
              </div>
            </FormGroup>
          </DropdownItem>
        ))}
      </DropdownMenu>
    </ButtonDropdown>
  ) : !row.children ? (
    "NA"
  ) : null
}

function ExpandableTableField(props) {
  const { name, label, required, metaData, value, onChange } = props
  const {
    menuHeaderOptions,
    menuSubHeaderOptions,
    menuItemFilterOptions,
    accessList,
  } = metaData

  console.log(value, "value")

  
  const tableColumns = (accessList || [])
    .filter((_) => _.isDefault)
    .reduce(
      (a, el) => {
        a.push({
          dataField: el._id,
          text: el.accessName,
          formatter: (rowVal, row) => {
            return !row.children && row.access.includes(el._id) ? (
              <FormGroup className="mb-3">
                <div className="form-check">
                  <Label
                    className="form-check-label"
                    htmlFor={`${row._id}-${el._id}`}
                  >
                    {" "}
                    {el.accessName}
                  </Label>
                  <Input
                    type="checkbox"
                    className="form-check-input"
                    id={`${row._id}-${el._id}`}
                    name={el._id}
                    onChange={(e) => {
                      const filterVal =
                        (value && value.filter((_) => _.menuId === row._id)) ||
                        []
                      const changedVal =
                        filterVal && filterVal.length > 0
                          ? (value || []).map((el) => {
                              if (
                                el &&
                                el.menuId &&
                                el.access &&
                                el.menuId === row._id &&
                                el.access.includes(e.target.name)
                              ) {
                                return Object.assign({}, el, {
                                  access: el.access.filter(
                                    (id) => id == e.target.name
                                  ),
                                })
                              } else if (
                                el &&
                                el.menuId &&
                                el.access &&
                                el.menuId === row._id &&
                                !el.access.includes(e.target.name)
                              ) {
                                return Object.assign({}, el, {
                                  access: [...el.access, e.target.name],
                                })
                              } else {
                                return el
                              }
                            })
                          : value && value.length > 0
                          ? [
                              ...value,
                              Object.assign(
                                {},
                                { menuId: row._id, access: [e.target.name] }
                              ),
                            ]
                          : [
                              Object.assign(
                                {},
                                { menuId: row._id, access: [e.target.name] }
                              ),
                            ]
                      onChange({ target: { value: changedVal } })
                    }}
                    checked={
                      (value &&
                        value.find(
                          (_) =>
                            _.menuId === row._id && _.access.includes(el._id)
                        )) ||
                      false
                    }
                  />
                </div>
              </FormGroup>
            ) : !row.children ? (
              "NA"
            ) : null
          },
        })
        return a
      },
      [
        {
          dataField: "menuName",
          text: "",
          formatter: (val, r) =>
            r.subHeader ? (
              <div className="d-flex">
                <Input
                  type="checkbox"
                  className="form-check-input"
                  name={r._id}
                  style={{ marginRight: "12px" }}
                  onChange={(e) => {
                    const filterVal =
                      (value && value.filter((_) => _.menuId === r._id)) || []
                    const itemMenu =
                      (menuItemFilterOptions || [])
                        .filter(
                          (g) =>
                            g.menuReferenceId.toString() === r._id.toString()
                        )
                        .map((t) => t._id) || []
                    const menuVal =
                      (itemMenu &&
                        itemMenu.length > 0 &&
                        (itemMenu || []).map((itemId) =>
                          Object.assign(
                            {},
                            {
                              menuId: itemId,
                              access: accessList.map((x) => x._id),
                            }
                          )
                        )) ||
                      []
                    const changedVal =
                      filterVal && filterVal.length > 0
                        ? (value || []).filter(
                            (k) =>
                              !itemMenu.includes(k.menuId) && k.menuId !== r._id
                          )
                        : value && value.length > 0
                        ? [
                            ...value.filter(
                              (k) => !itemMenu.includes(k.menuId)
                            ),
                            ...menuVal,
                            Object.assign(
                              {},
                              {
                                menuId: e.target.name,
                                access: accessList.map((x) => x._id),
                              }
                            ),
                          ]
                        : [
                            ...menuVal,
                            Object.assign(
                              {},
                              {
                                menuId: e.target.name,
                                access: accessList.map((x) => x._id),
                              }
                            ),
                          ]
                    onChange({ target: { value: changedVal } })
                  }}
                  checked={
                    (value && value.find((_) => _.menuId === r._id)) || false
                  }
                />
                <b>{capitalizeFirstLetter(val)}</b>
              </div>
            ) : (
              <div style={{ paddingLeft: "28px" }}>
                <Input
                  type="checkbox"
                  className="form-check-input"
                  name={r._id}
                  style={{ marginRight: "12px" }}
                  onChange={(e) => {

                    console.log("r", r)

                    const filterVal =
                      (value && value.filter((_) => _.menuId === r._id)) || []
                    const itemMenu =
                      (menuItemFilterOptions || [])
                        .filter(
                          (g) =>
                            g.menuReferenceId.toString() === r._id.toString()
                        )
                        .map((t) => t._id) || []
                    const menuVal =
                      (itemMenu &&
                        itemMenu.length > 0 &&
                        (itemMenu || []).map((itemId) =>
                          Object.assign(
                            {},
                            {
                              menuId: itemId,
                              access: accessList.map((x) => x._id),
                            }
                          )
                        )) ||
                      []
                    const changedVal =
                      filterVal && filterVal.length > 0
                        ? (value || []).filter(
                            (k) =>
                              !itemMenu.includes(k.menuId) && k.menuId !== r._id
                          )
                        : value && value.length > 0
                        ? [
                            ...value.filter(
                              (k) => !itemMenu.includes(k.menuId)
                            ),
                            ...menuVal,
                            Object.assign(
                              {},
                              {
                                menuId: e.target.name,
                                access: accessList.map((x) => x._id),
                              }
                            ),
                          ]
                        : [
                            ...menuVal,
                            Object.assign(
                              {},
                              {
                                menuId: e.target.name,
                                access: accessList.map((x) => x._id),
                              }
                            ),
                          ]
                    
                 onChange({ target: { value: changedVal } })
                  }}
                  checked={
                    (value && value.find((_) => _.menuId === r._id)) || false
                  }
                />
                {capitalizeFirstLetter(val)}
              </div>
            ),
        },
      ]
    )

  return (
    <React.Fragment>
      <FormGroup className="no-margin">
        <Label htmlFor={name}>
         {label} {required ? <span style={{ color: "red" }}>*</span> : null}
        </Label>
        {(menuHeaderOptions || []).map(({ _id, menuName }) => {
          const menuData = (menuSubHeaderOptions || [])
            .filter((s) => s.menuReferenceId.toString() === _id.toString())
            .reduce((arr, el) => {
              const menuItemData =
                (menuItemFilterOptions || []).filter(
                  (g) => g.menuReferenceId.toString() === el._id.toString()
                ) || []
              if (menuItemData && menuItemData.length > 0) {
                arr = [
                  ...arr,
                  Object.assign({}, el, {
                    subHeader: true,
                    children: true,
                    value,
                  }),
                  ...menuItemData.map((k) => Object.assign({}, k, { value })),
                ]
              } else {
                arr.push(Object.assign({}, el, { subHeader: true, value }))
              }
              return arr
            }, [])
          return (
            <div key={_id}>
              <div className="table-header d-flex">
                <Input
                  type="checkbox"
                  className="form-check-input"
                  name={_id}
                  style={{ marginRight: "12px", marginTop: "5px" }}
                  onChange={(e) => {
                    const filterVal =
                      (value && value.filter((_) => _.menuId === _id)) || []
                    const changedVal =
                      filterVal && filterVal.length > 0
                        ? (value || []).reduce((arr, el, i) => {
                            if (
                              el &&
                              el.menuId &&
                              el.access &&
                              el.menuId === _id
                            ) {
                              arr.splice(i, 1)
                            } else {
                              arr.push(el)
                            }
                            return arr
                          }, [])
                        : value && value.length > 0
                        ? [
                            ...value,
                            Object.assign(
                              {},
                              {
                                menuId: e.target.name,
                                access: accessList.map((x) => x._id),
                              }
                            ),
                          ]
                        : [
                            Object.assign(
                              {},
                              {
                                menuId: e.target.name,
                                access: accessList.map((x) => x._id),
                              }
                            ),
                          ]
                    onChange({ target: { value: changedVal } })
                  }}
                  checked={
                    (value && value.find((_) => _.menuId === _id)) || false
                  }
                />
                <h4>{capitalizeFirstLetter(menuName)}</h4>
              </div>
              <BootstrapTable
                keyField="_id"
                data={menuData}
                columns={tableColumns.concat([
                  {
                    dataField: "action",
                    text: "",
                    formatter: (val, row) => (
                      <DropdownFormatter
                        accessList={accessList}
                        onChange={onChange}
                        value={value}
                        row={row}
                      />
                    ),
                  },
                ])}
                expandRow={false}
              />
            </div>
          )
        })}
      </FormGroup>
    </React.Fragment>
  )
}

ExpandableTableField.propTypes = {
  t: PropTypes.any,
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  required: PropTypes.bool,
  metaData: PropTypes.object,
  onChange: PropTypes.any,
}

DropdownFormatter.propTypes = {
  t: PropTypes.any,
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  required: PropTypes.bool,
  metaData: PropTypes.object,
  accessList: PropTypes.any,
  row: PropTypes.any,
  onChange: PropTypes.any,
}

export default ExpandableTableField
